import Vue from 'vue';
import Vuex from 'vuex';
import { locationModule } from './modules/locations/location';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    location: locationModule,
  },
});
